import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { Card } from "@mui/material";
import { Users, Gift, Presentation } from "lucide-react";
import CountUp from "react-countup";

export default function StatsSection() {
  const [stats, setStats] = useState([
    {
      icon: Gift,
      value: 50,
      label: "Gifts",
      suffix: "+",
      description:
        "The word gift or a present is an item given to someone without the expectation of payment or anything in return.",
    },
    {
      icon: Presentation,
      value: 5,
      label: "Projects",
      suffix: "+",
      description:
        "A project is an activity to meet the creation of a unique product or service, and thus activities that are undertaken to accomplish routine activities cannot be considered projects.",
    },
    {
      icon: Users,
      value: 225,
      label: "Clients",
      suffix: "+",
      description:
        "The word client can also mean customer according to most dictionaries, but it has a separate definition as someone who receives professional services.",
    },
  ]);

  const { ref, inView } = useInView({
    threshold: 0.2,
  });

  const fetchCurrentStats = async () => {
    const url = "https://rohan-tax-services.onrender.com/api/auth/fetchstats";

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });

      if (response.ok) {
        const data = await response.json();
        sessionStorage.setItem("statsData", JSON.stringify(data));
        setStats((prevStats) =>
          prevStats.map((stat) => ({
            ...stat,
            value: data[stat.label] || 0,
          }))
        );
      } else {
        console.error("Failed to fetch stats:", response.status);
      }
    } catch (error) {
      console.error("Error fetching stats:", error);
    }
  };

  useEffect(() => {
    const storedStats = sessionStorage.getItem("statsData");
    if (storedStats) {
      const parsedStats = JSON.parse(storedStats);
      setStats((prevStats) =>
        prevStats.map((stat) => ({
          ...stat,
          value: parsedStats[stat.label] || 0,
        }))
      );
    } else {
      fetchCurrentStats();
    }
  }, []);

  return (
    <div ref={ref} className="py-24 bg-white">
      <div className="container px-4 mx-auto">
        <div className="grid gap-6 md:grid-cols-1 lg:grid-cols-3">
          {stats.map((stat, index) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: index * 0.2 }}
            >
              <Card className="p-8 h-full hover:scale-105 !transition-transform !duration-300">
                <div className="flex items-center space-x-10">
                  <div className="flex items-center justify-center text-[#151C62] mb-4">
                    <stat.icon size={40} />
                  </div>
                  <div>
                    {inView && (
                      <CountUp
                        start={0}
                        end={stat.value}
                        duration={3}
                        className="text-5xl font-bold tracking-tight text-[#151C62]"
                      />
                    )}
                    <span className="text-5xl font-bold tracking-tight text-[#151C62]">
                      {stat.suffix}
                    </span>
                  </div>
                </div>
                <h3 className="mt-4 text-xl font-medium text-gray-900">
                  {stat.label}
                </h3>
                <p className="mt-3 text-base text-gray-500 leading-relaxed">
                  {stat.description}
                </p>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
